import { axiosLoader } from "@fixit/utils";
import Vue from "vue";

/**
 * Eventbus to emit error messages to parent application
 * The error events are being caught in created() in 'TheFixitNoHeader.vue'
 * and emitted to parent to be displayed as a snackbar.
**/
export let AppEventbus = new Vue();

async function loadModules() {
  if (process.client && window) {
    await axiosLoader();
  }
}

/**
 * IMPORTANT!!
 * Service requires the parent application using the components to have it's axios instance correctly set up.
 */
import { User } from "../models";

export default async function ($axios) {

  if (!$axios) {
    await loadModules();
  }
  const _axios = $axios ? $axios : window.axios ? window.axios : null;
  const PaymentSvc = {
    /**
     * Fetches the active payment methods
     *
     * @param baseUrl - axios endpoint url
     * @returns {User}
     */
    async GetPaymentMethodsConfig(siteId) {
      return await _axios
        .get(
          process.env.VUE_APP_FIXIT_NO_BOOKING_URL +
            '/api/Payment/payment-methods' + '?siteId=' + siteId
        )
        .then((res) => {
          if (res.data.responseCode === 200) {
            return res.data.dto;
          }
        })
        .catch(function () {
          
        });
    },
  };

  return PaymentSvc;
}
